var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isView)?_c('advertisement-detail-component',{attrs:{"selected-row":_vm.selectedRow,"page-type":_vm.pageType,"store-floor-seq":_vm.detail.storeFloorSeq,"store-seq":_vm.detail.storeSeq,"mediaType":_vm.detail.mediaType,"advertisementSeq":_vm.detail.advertisementSeq}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }